exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".logo-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 4rem;\r\n    margin-bottom: 2rem;\r\n    min-width: 420px;\r\n}\r\n\r\n.logo-header .logo-image {\r\n    max-width: 300px;\r\n    width: 100%\r\n}\r\n\r\n.logo-header .logo-text-container {\r\n    font-size: 1.6rem;\r\n    font-weight: 700;\r\n    line-height: inherit;\r\n    margin: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/styles/common/logoHeader.component.css
// module id = 445
// module chunks = 0